// In-memory access token store — never persisted to localStorage/sessionStorage.
// The token lives only for the current page session; page reload requires re-login
// (or silent refresh via the HttpOnly refresh cookie).

let accessToken: string | null = null;

export const AUTH_SESSION_EXPIRED_EVENT = 'arch-editor:auth-session-expired';

export function setToken(token: string): void {
  accessToken = token;
}

export function getToken(): string | null {
  return accessToken;
}

export function clearToken(): void {
  accessToken = null;
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(AUTH_SESSION_EXPIRED_EVENT));
  }
}
